import React from 'react'

export default function ModalBackdrop () {
  return (
    <section className="modal-backdrop"/>
  )
}